import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore.js";

export function RequireAuth({
  children,
}: {
  children: ReactElement;
}): ReactElement {
  const staff = useAuthStore((state) => state.staff);
  const loading = useAuthStore((state) => state.loading);

  if (loading) {
    return <div className="page">読み込み中...</div>;
  }
  if (!staff) {
    return <Navigate to="/login" replace />;
  }
  if (staff.mustChangePin) {
    return <Navigate to="/change-pin" replace />;
  }
  return children;
}

export function RequireAdmin({
  children,
}: {
  children: ReactElement;
}): ReactElement {
  const staff = useAuthStore((state) => state.staff);
  const loading = useAuthStore((state) => state.loading);

  if (loading) {
    return <div className="page">読み込み中...</div>;
  }
  if (!staff) {
    return <Navigate to="/login" replace />;
  }
  if (staff.mustChangePin) {
    return <Navigate to="/change-pin" replace />;
  }
  if (staff.role !== "ADMIN" && staff.role !== "OWNER") {
    return (
      <div className="page">
        <div className="alert alert-error">
          この画面には管理者権限が必要です。
        </div>
      </div>
    );
  }
  return children;
}

export function RequireOwner({
  children,
}: {
  children: ReactElement;
}): ReactElement {
  const staff = useAuthStore((state) => state.staff);
  const loading = useAuthStore((state) => state.loading);

  if (loading) {
    return <div className="page">読み込み中...</div>;
  }
  if (!staff) {
    return <Navigate to="/login" replace />;
  }
  if (staff.mustChangePin) {
    return <Navigate to="/change-pin" replace />;
  }
  if (staff.role !== "OWNER") {
    return (
      <div className="page">
        <div className="alert alert-error">
          この画面にはオーナー権限が必要です。
        </div>
      </div>
    );
  }
  return children;
}
